import { takeLatest, put, call, select, take } from 'redux-saga/effects';
import { 
  getPaginatedEventReportsIfNeeded,
  getPaginatedEventHistoryIfNeeded,
  getEventReportCsvFile,
  getEventLogIfNeeded
} from './sagas';
import {
  GET_PAGINATED_EVENT_REPORTS,
  GETTING_PAGINATED_EVENT_REPORTS_FAILED,
  GET_PAGINATED_EVENT_HISTORY,
  GET_EVENT_REPORT_CSV_FILE,
  GET_EVENT_LOG
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest([GETTING_PAGINATED_EVENT_REPORTS_FAILED], function*(action) {
    yield put(
      userMessaging.setMessageForFailedAction({
        type: action.type,
        error: action.payload
      })
    );
  });
}

function* PaginatedEventReportsGetManySaga() {
  yield takeLatest(GET_PAGINATED_EVENT_REPORTS, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedEventReportsIfNeeded, action);
  });
}

function* PaginatedEventHistoryGetManySaga() {
  yield takeLatest(GET_PAGINATED_EVENT_HISTORY, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedEventHistoryIfNeeded, action);
  });
}

function* GetEventReportFileSaga() {
  yield takeLatest(GET_EVENT_REPORT_CSV_FILE, getEventReportCsvFile);
}

function* GetEventLogSaga() {
  yield takeLatest(GET_EVENT_LOG, getEventLogIfNeeded);
}

export default [
  PaginatedEventReportsGetManySaga,
  HandleFailuresSaga,
  PaginatedEventHistoryGetManySaga,
  GetEventReportFileSaga,
  GetEventLogSaga
];
